// Get the current domain without protocol.
const { hostname: currentDomain } = window.location;
// Grab localized data.
const { excludeList = [] } = window.emExternalLinks || {};

const isExcludedDomain = (domain) => {
	// Validate the domain to avoid potential XSS vulnerabilities.
	if (!domain || typeof domain !== 'string') {
		return false;
	}
	return excludeList.includes(domain);
};

if (excludeList.length) {
	// Add a click event listener to the body
	document.addEventListener('click', (event) => {
		// Compare the domains and open the link in a new tab if they don't match.
		const link = event.target.closest('a');

		if (link && link.href) {
			// Extract the domain without the protocol.
			const { hostname: linkDomain } = new URL(link.href);
			// Check if the domain is excluded or matches the current domain.
			if (!isExcludedDomain(linkDomain) && linkDomain !== currentDomain) {
				// Prevent the link from opening on its own.
				event.preventDefault();
				// Open the link in a new tab with rel="noopener noreferrer" for security.
				window.open(link.href, '_blank', 'noopener noreferrer');
			}
		}
	});
}
